// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { HallMemberMenu } from './hall-member-menu'

const COMPONENT = 'hallMemberMenu'

export const showHallMemberMenu = (
  props: Omit<Parameters<typeof HallMemberMenu>[0], 'isOpen'>,
  preventBackClick = false,
) => addModal({ id: COMPONENT, props, preventBackClick })

export default {
  [COMPONENT]: { Component: HallMemberMenu },
}
